<script setup lang="ts">
import type { DeTableProperties } from '@/pages/erp/de/select/db/de-table-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'DESELECT',
    },
})

const router = useRouter()

const compId = ref(useStorage('compNo', 'nstc').value)
const tabId = ref('')
const tabName = ref('')

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '表格編號', key: 'tabId' },
    { title: '表格名稱', key: 'tabName' },
    { title: '註解', key: 'tabComment' },
    { title: '操作', key: 'actions', sortable: false}
]



// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: deTablesData, execute: fetchDeTables } = await useApi<any>(createUrl('/de/select/table/searchDeTable', {
  query: {
    compId,
    tabId,
    tabName,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): DeTableProperties[] => deTablesData.value.data.deTablePage.content)
const totalDatas = computed(() => deTablesData.value.data.deTablePage.totalElements)

console.log('datas: ', datas)

const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
    router.push({ name: 'erp-de-select-view-tab-id', params: { tabId: 'newData' } })
}

const editData = (deTableData: DeTableProperties) => {
  router.push({ name: 'erp-de-select-view-tab-id', params: { tabId: deTableData.tabId } })
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow> 
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="tabId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入表格編號"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="tabName"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入表格名稱"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增共用表格
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            hover
            @update:options="updateOptions"
    >
      
      <template #item.tabId="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.tabId }}
          </div>
          
      </template>
      
      <template #item.tabName="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.tabName }}
          </div>
          
      </template>
      
      <template #item.tabComment="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.tabComment }}
          </div>
          
      </template>
      
      <!-- Actions -->
      <template #item.actions="{ item }">
          <IconBtn @click="editData(item)">
              <VIcon icon="tabler-edit" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >編輯</v-tooltip>
          </IconBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->

</template>
